import { formatMoney } from '@shopify/theme-currency';
import { initFriendFamilyShare } from './friends-family-share';
import checkProductsExist from './check-products-exist';
// import initShareFacebookWishlist from './facebook-share';
import { initSharedWishlistPage } from './shared-wishlist';
import initLinkShare from './link-share';
import initSavedForLaterTiles from './save-for-later';
import initMoveToWishlist from './move-to-wishlist';
import initRemoveFromWishlist from './remove-from-wishlist';
import initMoveToCart from './move-to-cart';
import getProductID from './get-product-id';
import getTileHTML from './get-tile-html';
// import { openSliderCart } from '../../sections/slider-cart';

// Save the list products on load to be able to send the object on remove
window.wishlist_products = [];

/*
// Native wishlist landing ONLY /apps/swymWishlist/wishlist/
const removeAddedItems = () => {
  _.each($('.swym-item'), (item) => {
    if ($(item).find('.swym-add-to-cart a').text() === 'Added') {
      $(item).remove();
    }
  });
};
*/

// Collection page / Search overlay
const initProductTileWishlist = () => {
  function swymCallbackTileFn (swat) {
    document.addEventListener('tile-variant:change', (e) => {
      try {
        const variant_id = e.data.detail.variantId;
        const $tile = e.data.detail.tile;
        const selector = `[data-product-tile][data-product-id="${$tile.data('product-id')}"] [data-product-swym-wishlist]`;
  
        const swym_qv = document.querySelector(selector);
        if (swym_qv === null || typeof swym_qv === 'undefined') {
          return;
        }

        swym_qv.setAttribute('data-variant-id', variant_id);
        swat.initializeActionButtons(`[data-product-tile][data-product-id="${$tile.data('product-id')}"]`);
      } catch (e) {
        console.log(e);
      }
    });
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(swymCallbackTileFn);
};

const initWishlistTiles = () => {
  const wishlistItemsContainer = document.getElementById('wishlist-items');

  if (!wishlistItemsContainer) {
    return;
  }

  window._swat.fetch((wishlistProducts) => {
    // console.log('wishlistProducts', wishlistProducts);
    window.wishlist_products = wishlistProducts;

    $('[data-cart-wishlist-loading]').remove();

    if (!wishlistProducts.length) {
      // Cart page
      if ($('[data-cart-wishlist-empty]').length) {
        $('[data-cart-wishlist-empty]').addClass('visible');
      }

      // User's wishlist page
      if ($('.user-wishlist__empty').length) {
        $('[data-cart-wishlist-empty]').remove();
        $('.user-wishlist__empty').removeClass('visually-hidden');
      }
      return;
    }

    // Need to remove it to avoid messing up the tiles grid
    $('[data-cart-wishlist-empty]').remove();

    // Show the share section on the user's wishlist page
    if ($('.user-wishlist-share').length) {
      $('.user-wishlist-share').removeClass('visually-hidden');
    }

    let count_whishlist_item = 0;
    _.each(wishlistProducts, (wishlistProduct) => {
      try {
        const wishlist_product_id = getProductID(wishlistProduct);
        wishlistProduct.id = wishlist_product_id;

        if (wishlist_product_id !== null) {
          const option_html = getTileHTML(wishlistProduct, wishlistItemsContainer);

          $(`[data-cart-wishlist-items] [data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-options]`).html(option_html);
          // $(`[data-cart-wishlist-items] [data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-price]`).html(`<span>${parseFloat(wishlistProduct.pr, 10).toFixed(2)}</span>`);
  
          if (window.Shopify.country === 'US') {
            $(`[data-cart-wishlist-items] [data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-price]`).html(formatMoney(Number(wishlistProduct.pr) * 100, theme.moneyFormat));
          } else {
            $(`[data-cart-wishlist-items] [data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-price]`).html(formatMoney(Math.ceil(Number(wishlistProduct.pr) * window.Shopify.currency.rate) * 100, theme.moneyFormat));
          }
  
          // Cleanup title
          let product_title = wishlistProduct.dt;
          if (product_title.indexOf(' - ') !== -1) {
            const product_title_parts = product_title.split(' - ');
            const last_title_part = product_title_parts[product_title_parts.length - 1];
            product_title = product_title.replace(` - ${last_title_part}`, '');
            $(`[data-cart-wishlist-items] [data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-title]`).html(product_title);
          }
  
          count_whishlist_item++;
  
          // User might have a product that doesn't exist in store in its wishlist, remove it if it's the case
          if (count_whishlist_item === wishlistProducts.length) {
            checkProductsExist(wishlistProducts, 'wishlist');
          }
  
          $(window).trigger('resize');
        }
      } catch (error) {
        console.log('Wishlist error', error);
      }
    });
  }, window._swat.EventTypes.addToWishList);
};

let swym_ready_checks = 0;
const swymCallbackFn = () => {
  return new Promise(async (resolve, reject) => {
    if (typeof window._swat === 'undefined' && swym_ready_checks < 5) {
      window.setTimeout(() => {
        swym_ready_checks++;
        swymCallbackFn();
      }, 1000);

      return;
    }

    initWishlistTiles();
    initSavedForLaterTiles();

    resolve(true);
  });
};

// List tiles (Wishlist and Saved for Later)
const initListTiles = () => {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  initMoveToCart();

  window.SwymCallbacks.push(swymCallbackFn);
};

// Gets initialized on every pages from theme.js
const initWishlist = () => {
  // Redirects to custom wishlist page
  if (window.location.href.indexOf('/apps/swymWishlist/wishlist/') !== -1 || window.location.href.indexOf('/pages/swym-wishlist') !== -1) {
    window.location.href = `${window.Shopify.routes.root}pages/wishlist/`;
  }

  // We want to sync the icon on product overview, sticky add to cart mobile and desktop
  // But it looks like we're only able to get the event when removing the item from the wishlist
  // $(document).on('click', '[data-product-details-wishlist]', (e) => {
  //   const $item = $(e.currentTarget).find('[data-product-swym-wishlist]');
  //   const is_removing = $item.hasClass('swym-added');

  //   if (is_removing) {
  //     $('[data-product-swym-wishlist]').removeClass('swym-added');

  //     $('[data-product-swym-wishlist]').each((wishlist_button) => {
  //       $(wishlist_button).removeClass('swym-added');
  //     });
  //   } else {
  //     $('[data-product-swym-wishlist]').each((wishlist_button) => {
  //       $(wishlist_button).addClass('swym-added');
  //     });
  //   }
  // });

  $(document).on('click', '[data-open-signin-actions-modal]', (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (window.theme.isLoggedIn === true) {
      return;
    }

    const $item = $(e.currentTarget);
    const sign_in_type = $item.data('openSigninActionsModal'); // wishlist or saveforlater
    const $modal = $('[data-signin-actions-modal]');

    $modal.modal({
      fadeDuration: 250,
      fadeDelay: 0.80,
    });

    $modal.off($.modal.BEFORE_OPEN);
    $modal.on($.modal.BEFORE_OPEN, () => {
      $('[data-signin-actions-modal] .modal__wishlist').addClass('visually-hidden');
      $('[data-signin-actions-modal] .modal__saveforlater').addClass('visually-hidden');
      $('[data-signin-actions-modal] .modal__countdown').addClass('visually-hidden');

      if (sign_in_type === 'wishlist') {
        $('[data-signin-actions-modal] .modal__wishlist').removeClass('visually-hidden');
      }

      if (sign_in_type === 'saveforlater') {
        $('[data-signin-actions-modal] .modal__saveforlater').removeClass('visually-hidden');
      }

      if (sign_in_type === 'countdown') {
        $('[data-signin-actions-modal] .modal__countdown').removeClass('visually-hidden');
      }
    });

    $modal.off($.modal.OPEN);
    $modal.on($.modal.OPEN, () => {
      // [ADA]
      $('#quicklook-modal .close-modal').attr('role', 'button');
      $('#quicklook-modal .close-modal').trigger('focus');
      $('#quicklook-modal .close-modal').removeAttr('style');
    });
  });

  // if (!$('[data-product-swym-wishlist]').length && window.location.pathname.indexOf('swymWishlist') === -1) {
  //   return;
  // }

  // Collection pages / Search overlay
  initProductTileWishlist();

  // Product overview on PDP only
  // if (window._swat && $('.product-actions__wishlist').length) {
  //   window._swat.initializeActionButtons('.product-actions__wishlist');
  // }
  // try {
  //   if (window._swat && $('.swym-add-to-wishlist-view-product').length) {
  //     window._swat.initializeActionButtons('.swym-add-to-wishlist-view-product');
  //   }
  // } catch (error) {
  //   console.log(error);
  // }

  // Native wishlist landing ONLY /apps/swymWishlist/wishlist/
  /*
  if (window.location.pathname.indexOf('swymWishlist') !== -1) {
    const wishlist_landing_ready = window.setInterval(() => {
      if ($('body').hasClass('swym-ready')) {
        $(window).trigger('resize');
        removeAddedItems();

        window.setTimeout(() => {
          $(window).trigger('resize');
        }, 1000);
        window.clearInterval(wishlist_landing_ready);
      }
    }, 250);
  }
  */

  if ($('#wishlist-items').length || $('#saveforlater-items').length) {
    initListTiles();
  }

  // Custom wishlist landing and cart page
  if ($('#wishlist-items').length) {
    // initShareFacebookWishlist();
    initMoveToWishlist();
    initRemoveFromWishlist();
  }

  // Share wishlist friends & family
  initFriendFamilyShare();

  // Shared wishlist page
  // https://www.astrthelabel.com/pages/shared-wishlist?hkey=93d27de5-5845-4feb-96c6-d98860dc959e&lid=93d27de5-5845-4feb-96c6-d98860dc959e
  initSharedWishlistPage();

  if ($('[data-open-share-wishlist-link-modal]').length) {
    initLinkShare();
  }

  // if ($('#friends-amp-family').length) {
  //   shareListByEmail();
  // }
};

// The wishlist icon from the product overview is the reference (native button). It takes a short moment to get all the necessary classes
let count_is_loaded_wishlist = 0;
const propagateWishlistStateToStickyAddToCart = (on_init = false) => {
  // 30 seconds max
  const stop_after = 30;
  const is_loaded = $('[data-product-overview] .swym-add-to-wishlist').hasClass('swym-loaded');
  console.log(`[wishlist] is_loaded #${count_is_loaded_wishlist}`, is_loaded);

  // It takes a few seconds for the wishlist to initialize
  if (on_init && count_is_loaded_wishlist < stop_after) {
    if (!is_loaded) {
      window.setTimeout(() => {
        propagateWishlistStateToStickyAddToCart(on_init);
        count_is_loaded_wishlist++;
      }, 1000);
    }

    if (typeof window.theme.customer.id === 'undefined') {
      $('.swym-btn-container').prepend('<div class="product-actions__wishlist-clickable" data-wishlist-clickable aria-label="Wishlist" role="button" tabindex="0" data-open-signin-actions-modal="wishlist"></div>');
    } else {
      $('.swym-btn-container').prepend('<div class="product-actions__wishlist-clickable" data-wishlist-clickable aria-label="Wishlist" role="button" tabindex="0"></div>');
    }
  }

  /*
  if (!is_loaded) {
    return;
  }
  
  let count_wishlist_added_check = 0;
  const wishlist_added_ready = window.setInterval(() => {
    count_wishlist_added_check++;

    const is_added = $('[data-product-overview] .swym-add-to-wishlist').hasClass('swym-added');
    console.log('[wishlist] is_added', is_added);

    if (is_added) {
      $('[data-product-details-wishlist]').addClass('active');
      window.clearInterval(wishlist_added_ready);
    } else {
      $('[data-product-details-wishlist]').removeClass('active');

      if (count_wishlist_added_check > 100) {
        window.clearInterval(wishlist_added_ready);
      }
    }
  }, 250);
  */
};

export {
  initWishlist,
  initProductTileWishlist,
  propagateWishlistStateToStickyAddToCart,
};
